import styled from "styled-components";

export const UserMessageStyled = styled.div`
  padding: 1.2rem;
  max-width: 35rem;
  border-radius: 0.6rem;
  background-color: #dae8ff;
  box-shadow: 0px 4px 10px 0px #0000000f;
`;
